export default "__VITE_ASSET__CY1bMv8C__"